import { EXTRA_CTRL_TYPE } from "@/commons/enums/extra-control-code";
import { EXTRA_SINGAL } from "@/commons/enums/extra-singal";
import { BasicControl, CURSOR_TYPE, DYMODE_MODE, ExtrudeSolidT, Line, Listeners, MOUSE, Plane, PlineT, Point, Polygon, RegionT, SelectionBox, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { Vector2, Vector3 } from "three";
import { AddWindowToBoundingWallCommand, BoundingWallT, WindowT } from "tnbimbase";

export class AssembleWindowControl extends BasicControl {
    id = EXTRA_CTRL_TYPE.ASSEMBLE_WINDOW;

    needInit: boolean;


    // step:0 选择要放置窗的平面
    // step:1 放置窗
    step: number = 0

    layerUuid: string;
    // 选择的要放置窗的体
    selectedSolid: BoundingWallT;
    // 选择的要开洞的体的平面
    rightFacesMap: { [key: number]: RegionT } = {};
    // 窗临时图元
    helpWindow: WindowT;
    // 布置在了墙的哪个curve上
    boundingWallCurveIndex: number;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    point_down: Point = new Point();
    point_move: Point = new Point();

    capturePoint: Vector3;

    // 窗要布置的工作平面，局部坐标轴
    workPlane: Plane = new Plane();
    axisZ: Vector3 = new Vector3();
    axisX: Vector3 = new Vector3();

    initWindowData: any


    private _pickBox: SelectionBox
    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = true;

        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();

        this.editor = editor;
        this.listeners = listeners;

        this.listeners.getSignal(EXTRA_SINGAL.onAssembleWindow).add(this.onAssembleWindow);
        this._pickBox = new SelectionBox(editor.camera);
        // 钝化夹点
        this.editor.clampControl.enabled = false;
        console.log('AssembleWindowControl added')
    }

    dispose(): void {
        this.listeners.getSignal(EXTRA_SINGAL.onAssembleWindow).remove(this.onAssembleWindow);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.extraContext.selectContext.forceMeshSelect = false;  //取消强制使用面选择
        this.listeners.signals.onOnePickOnly.dispatch(false);
        if (this.helpWindow && this.helpWindow.viewObj && this.helpWindow.viewObj.parent) {
            this.helpWindow.viewObj.parent?.remove(this.helpWindow.viewObj);
        }

        console.log('AssembleWindowControl removed')
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    generateWindow = (wallWidth: number) => {
        let horizontalSpace = this.initWindowData?.horizontalSpace
        let verticalSpace = this.initWindowData?.verticalSpace
        let aluminiumAlloyTexture = this.initWindowData?.aluminiumAlloyTexture
        let glassTexture = this.initWindowData?.glassTexture

        let horizontalArr: number[] = this.parseNumberArrAccumulate(horizontalSpace);
        let verticalArr: number[] = this.parseNumberArrAccumulate(verticalSpace);
        let width: number = horizontalArr?.length > 0 ? horizontalArr[horizontalArr?.length - 1] : 0;
        let height: number = verticalArr?.length > 0 ? verticalArr[verticalArr?.length - 1] : 0;
        if (width == 0) {
            // 窗宽为0
            this.extraContext.stmodeContext.pushTip(`窗宽为0`);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (height == 0) {
            // 窗高为0
            this.extraContext.stmodeContext.pushTip(`窗高为0`);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        width -= 100
        height -= 100
        // 构造窗图元
        // 窗框，窗框宽50mm，深100mm
        let frameWidth = 50;
        let frameDeep = wallWidth / 2;
        let direction = new Vector3(0, 0, -1);
        let outFramePolygon = new Polygon([], new Vector3(1, 0, 0), new Point(0, 0, 0));
        let outFramePoints: Point[] = [
            new Point(0, 0, 0),
            new Point(0, height + frameWidth * 2, 0),
            new Point(width + frameWidth * 2, height + frameWidth * 2, 0),
            new Point(width + frameWidth * 2, 0, 0),
        ]
        let outCurves = [];
        for (let i = 0; i < outFramePoints.length; i++) {
            if (i != outFramePoints.length - 1) {
                outCurves.push(new Line(outFramePoints[i], outFramePoints[i + 1]));
            } else {
                outCurves.push(new Line(outFramePoints[i], outFramePoints[0]));
            }
        }
        outFramePolygon.set(outCurves);
        let inFramePoints: Point[] = [
            new Point(frameWidth, frameWidth, 0),
            new Point(width + frameWidth, frameWidth, 0),
            new Point(width + frameWidth, height + frameWidth, 0),
            new Point(frameWidth, height + frameWidth, 0),
        ]
        let inCurves = [];
        for (let i = 0; i < inFramePoints.length; i++) {
            if (i != inFramePoints.length - 1) {
                inCurves.push(new Line(inFramePoints[i], inFramePoints[i + 1]));
            } else {
                inCurves.push(new Line(inFramePoints[i], inFramePoints[0]));
            }
        }
        let hole = new Polygon(inCurves, new Vector3(1, 0, 0));
        outFramePolygon.holes = [hole];
        let frameSolid = new ExtrudeSolidT(outFramePolygon, direction, frameDeep);
        // 赋铝合金的材质
        if (aluminiumAlloyTexture) {
            frameSolid.materialMap = { [aluminiumAlloyTexture]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] };
            frameSolid.needUpdate = true;
            frameSolid.needTextureMaterial = true;
        }
        let windowEntities = [];
        windowEntities.push(frameSolid);

        let baseX: number = Number(frameWidth);
        let baseY: number = Number(frameWidth);
        let baseZ: number = Number(0);

        let heightY = baseY + height;

        // 窗的纵分割杆，根据横向分割生成
        if (horizontalArr?.length > 1) {
            for (let i = 0; i < horizontalArr.length - 1; i++) {
                let item = horizontalArr[i];
                let leftBottom = new Vector3(baseX + item - frameWidth / 2 - frameWidth, baseY, baseZ);
                let leftTop = new Vector3(baseX + item - frameWidth / 2 - frameWidth, heightY, baseZ);
                let rightTop = new Vector3(baseX + item + frameWidth / 2 - frameWidth, heightY, baseZ);
                let rightBottom = new Vector3(baseX + item + frameWidth / 2 - frameWidth, baseY, baseZ);
                let solid = new ExtrudeSolidT(new Polygon([
                    new Line(leftBottom, leftTop),
                    new Line(leftTop, rightTop),
                    new Line(rightTop, rightBottom),
                    new Line(rightBottom, leftBottom),
                ], new Vector3(1, 0, 0), new Point(leftBottom.x, leftBottom.y, leftBottom.z)), direction, frameDeep);
                // 赋铝合金的材质
                if (aluminiumAlloyTexture) {
                    solid.materialMap = { [aluminiumAlloyTexture]: [0, 1, 2, 3, 4, 5] };
                    solid.needUpdate = true;
                    solid.needTextureMaterial = true;
                }
                windowEntities.push(solid);
            }
        }

        let widthX = baseX + width;

        // 窗的横分割杆，根据纵向分割生成
        if (verticalArr?.length > 1) {
            for (let i = 0; i < verticalArr.length - 1; i++) {
                let item = verticalArr[i];
                let leftBottom = new Vector3(baseX, heightY - item - frameWidth / 2 + frameWidth, baseZ);
                let leftTop = new Vector3(baseX, heightY - item + frameWidth / 2 + frameWidth, baseZ);
                let rightTop = new Vector3(widthX, heightY - item + frameWidth / 2 + frameWidth, baseZ);
                let rightBottom = new Vector3(widthX, heightY - item - frameWidth / 2 + frameWidth, baseZ);
                let solid = new ExtrudeSolidT(new Polygon([
                    new Line(leftBottom, leftTop),
                    new Line(leftTop, rightTop),
                    new Line(rightTop, rightBottom),
                    new Line(rightBottom, leftBottom),
                ], new Vector3(1, 0, 0), new Point(leftBottom.x, leftBottom.y, leftBottom.z)), direction, frameDeep);
                // 赋铝合金的材质
                if (aluminiumAlloyTexture) {
                    solid.materialMap = { [aluminiumAlloyTexture]: [0, 1, 2, 3, 4, 5] };
                    solid.needUpdate = true;
                    solid.needTextureMaterial = true;
                }
                windowEntities.push(solid);
            }
        }

        // 窗，窗厚20mm
        let windowDeep = 20;
        let windowPolygon = new Polygon([], new Vector3(1, 0, 0), new Point(frameWidth, (frameDeep - windowDeep) / 2, frameWidth));
        let windowPoints: Point[] = [
            new Point(frameWidth, frameWidth, 0),
            new Point(frameWidth, height + frameWidth, 0),
            new Point(width + frameWidth, height + frameWidth, 0),
            new Point(width + frameWidth, frameWidth, 0),
        ]
        let windowCurves = [];
        for (let i = 0; i < windowPoints.length; i++) {
            if (i != windowPoints.length - 1) {
                windowCurves.push(new Line(windowPoints[i], windowPoints[i + 1]));
            } else {
                windowCurves.push(new Line(windowPoints[i], windowPoints[0]));
            }
        }
        windowPolygon.set(windowCurves);
        let windowSolid = new ExtrudeSolidT(windowPolygon, direction, windowDeep);
        // 赋玻璃的材质
        if (glassTexture) {
            windowSolid.materialMap = { [glassTexture]: [0, 1] };
            windowSolid.needUpdate = true;
            windowSolid.needTextureMaterial = true;
        }
        windowEntities.push(windowSolid);
        this.helpWindow = new WindowT(new Point(0, 0, 0), windowEntities, '窗', new Vector3(0, 0, 1), new Vector3(1, 0, 0), width + 100, height + 100);
    }

    // 将数组累加
    parseNumberArrAccumulate = (str: string) => {
        let parsedArray = this.parseStr2NumberArr(str);
        return parsedArray?.reduce((accumulator, currentValue, index) => {
            if (index === 0) {
                accumulator.push(currentValue);
            } else {
                const accumulatedValue = accumulator[index - 1] + currentValue;
                accumulator.push(accumulatedValue);
            }
            return accumulator;
        }, []);
    }

    // 将网格数据转为可编辑数据
    parseStr2NumberArr = (str: string) => {
        if (!str) {
            return [];
        }
        const parts = str.split(',');

        try {
            const result = parts.flatMap((part) => {
                const multiplicationParts = part.split('*');
                if (multiplicationParts.length === 2) {
                    const number = parseInt(multiplicationParts[0], 10);
                    const count = parseInt(multiplicationParts[1], 10);

                    if (!isNaN(number) && !isNaN(count)) {
                        return Array.from({ length: count }, () => number);
                    }
                } else {
                    const number = parseInt(part, 10);
                    if (!isNaN(number)) {
                        return [number];
                    }
                }

                return [];
            });

            return result;
        } catch (error) {
            return [];
        }
    }

    initControl(data: any): void {
        this.onAssembleWindow(data)
    }

    onAssembleWindow = (data: {
        horizontalSpace: string,
        verticalSpace: string,
        aluminiumAlloyTexture: string,
        glassTexture: string,
        layerUuid: string
    }) => {
        let initData = {
            ...data
        }
        this.listeners.signals.setInitControlData.dispatch(initData);
        this.layerUuid = data.layerUuid;
        // 判断横向分割
        if (data?.horizontalSpace == undefined || data?.horizontalSpace === '' || data?.horizontalSpace?.trim() === '') {
            this.extraContext.stmodeContext.pushTip(`缺少窗组件`);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return null;
        }
        // 判断纵向分割
        if (data?.verticalSpace == undefined || data?.verticalSpace === '' || data?.verticalSpace?.trim() === '') {
            this.extraContext.stmodeContext.pushTip(`缺少窗组件`);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return null;
        }
        this.initWindowData = { ...data }
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.extraContext.dymodeContext.setDymodeTip('选择墙上的平面:');
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.TIPONLY);
        this.extraContext.stmodeContext.setStmode('选择墙上的平面');
        this.listeners.signals.onOnePickOnly.dispatch(true);
        // 激活选择
        this.editor.selectControl.setEnabled(true);
        this.editor.clampControl.hidden = true;
        this.extraContext.selectContext.forceMeshSelect = true;  //强制使用面选择
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 监听鼠标按下
        this.editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
    }

    _dymodeActive = false;
    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.point_down.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        }
    }

    private _foot = new Vector3();
    onKeyMouseConfirm = () => {
        if (this.step == 0) {
            this.extraContext.stmodeContext.pushTip(`请选择墙上的平面`);
        } else if (this.step == 1) {
            if (!this._dymodeActive) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            } else {
                this.workPlane.projectPoint(this.point_down, this._foot);
                this.point_down.copy(this._foot);
                this.insertWindow();
            }
        }
    }

    private _pointLast = new Point();
    private _rightPline: PlineT = new PlineT();

    // 获取所有的平面
    // todo 目前只获得墙面外面的平面
    getSelectedFaces() {
        const boundingWall = this.selectedSolid;
        this._rightPline = boundingWall.basePline.clone();
        if (boundingWall.rightWidth > 0) {
            this._rightPline.offsetToLeft(false, boundingWall.rightWidth);
        }
        this._rightPline._geoCurves.forEach((item, index) => {
            if (item.type == 'Line') {
                let line = item as Line;
                let start = line.getPointAt(0);
                let end = line.getPointAt(1);
                let heightDelta = boundingWall._geo.direction.clone().multiplyScalar(boundingWall._geo.height);
                let topStart = start.clone().add(heightDelta);
                let topEnd = end.clone().add(heightDelta);
                let region = new RegionT([
                    new Line(start, end),
                    new Line(end, topEnd),
                    new Line(topEnd, topStart),
                    new Line(topStart, start),
                ])
                this.rightFacesMap[index] = region;
            }
        })
    }

    private _dir = new Vector3();

    onPointerMove = (event) => {
        if (!!!this.helpWindow) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_move, this.workPlane);
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }
        this.workPlane.projectPoint(this.point_move, this._foot);
        this.point_move.copy(this._foot);
        this._dir.subVectors(this.point_move, this.helpWindow.position)
        let length = this._dir.length();
        this._dir.normalize();
        this.helpWindow.move(this._dir, length);
        this.helpWindow.updateViewGeometry();
        this._pointLast.copy(this.point_move);
        this.listeners.signals.needRender.dispatch();
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        if (this.step == 0) {
            let selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock && entity.baseType == "ExtrudeSolidT");
            if (selectedEntities.length > 0) {
                this.editor.selectControl.setEnabled(false);
                this.selectedSolid = selectedEntities[0] as BoundingWallT;
                this.getSelectedFaces();
                let mesh: RegionT = this.getSelectedMesh(event);
                if (mesh == null) {
                    this.extraContext.stmodeContext.pushTip(`请选择墙上的平面`);
                    return;
                }
                this.generateWindow(this.selectedSolid.leftWidth + this.selectedSolid.rightWidth)
                // 窗要放置的面作为工作平面
                // 窗的z轴朝外
                this.workPlane.copy(mesh._geoPolygon);
                // 当前光标在该面上的坐标
                let rect = this.editor.renderer.domElement.getBoundingClientRect();
                let x = (event.clientX - rect.x) / rect.width * 2 - 1;
                let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
                this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down, this.workPlane);
                // 移动位置
                this._dir.subVectors(this.point_down, this.helpWindow.position)
                let length = this._dir.length();
                this._dir.normalize();
                this.helpWindow.move(this._dir, length);
                // 将窗转至该平面上
                let normalRotateAxis = this.helpWindow.normal.clone().cross(this.workPlane.normal).normalize();
                if (Math.abs(this.workPlane.normal.dot(this.helpWindow.normal) + 1) < 1e-6) {
                    normalRotateAxis = this.helpWindow.axisX.clone();
                }
                let normalDeltaAngle = this.workPlane.normal.angleTo(this.helpWindow.normal);
                this.helpWindow.rotate(this.point_down, normalRotateAxis, normalDeltaAngle);
                // 窗是朝上的，是0,0,1
                this.axisX.copy(new Vector3(0, 0, 1)).cross(this.workPlane.normal).normalize();
                let tempAxisX = this.helpWindow.axisX;
                let axisXRotateAxis = tempAxisX.clone().cross(this.axisX).normalize();
                let axisXDeltaAngle = tempAxisX.angleTo(this.axisX);
                if (axisXRotateAxis.length() < 1e-6 || Math.abs(tempAxisX.dot(this.axisX) + 1) < 1e-6) {
                    axisXRotateAxis = this.workPlane.normal.clone();
                }
                this.helpWindow.rotate(this.point_down, axisXRotateAxis, axisXDeltaAngle);
                // 显示临时图元
                if (this.helpWindow && this.helpWindow.viewObj && this.helpWindow.viewObj.parent) {
                    this.helpWindow.viewObj.parent?.remove(this.helpWindow.viewObj);
                }
                this._pointLast.copy(this.point_down);
                this.helpWindow.render();
                this.extraContext.sceneContext.scene.add(this.helpWindow.viewObj);
                // 下一步，放置窗
                this.step = 1;
                this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
                this.listeners.signals.sendToDymodeTip.dispatch('指定窗位置:');
                this.extraContext.stmodeContext.setStmode('指定窗位置');
                this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
                this.listeners.signals.needCapture.dispatch();
                this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
                this.listeners.signals.onPointCapture.add(this.onPointCapture);
                // 钝化选择
                this.listeners.signals.emptySelectedEntities.dispatch();
                this.editor.selectControl.setEnabled(false);
                // 监听鼠标移动
                this.editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
            }
        } else if (this.step == 1) {
            // 指定了窗位置
            let rect = this.editor.renderer.domElement.getBoundingClientRect();
            let x = (event.clientX - rect.x) / rect.width * 2 - 1;
            let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
            this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down, this.workPlane);
            if (this.capturePoint) {
                this.point_down.copy(this.capturePoint);
            }
            this.workPlane.projectPoint(this.point_down, this._foot);
            this.point_down.copy(this._foot);
            this.insertWindow();
        }
    }

    insertWindow = () => {
        this._dir.subVectors(this.point_down, this.helpWindow.position)
        let length = this._dir.length();
        this._dir.normalize();
        this.helpWindow.move(this._dir, length);
        this.helpWindow.updateViewGeometry();
        this._pointLast.copy(this.point_move);
        let window: WindowT = this.helpWindow.clone();
        window.layerUuid = this.layerUuid;
        window.isColorByLayer = true;
        window.boundingWallCurveIndex = this.boundingWallCurveIndex;
        this.editor.history.execute(new AddWindowToBoundingWallCommand((this.selectedSolid as BoundingWallT), window));
        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    // 获得选中的面
    getSelectedMesh(event) {
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let PickEpsilon = this.extraContext.editStatusContext.PickEpsilon;
        let top_left_x = event.clientX - PickEpsilon;
        let top_left_y = event.clientY - PickEpsilon;
        let bottom_right_x = event.clientX + PickEpsilon;
        let bottom_right_y = event.clientY + PickEpsilon;

        let start_x = (top_left_x - rect.x) / rect.width * 2 - 1;
        let start_y = -(top_left_y - rect.y) / rect.height * 2 + 1;
        let end_x = (bottom_right_x - rect.x) / rect.width * 2 - 1;
        let end_y = -(bottom_right_y - rect.y) / rect.height * 2 + 1;
        this._pickBox.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y))
        let rightSelected = [];
        for (let key in this.rightFacesMap) {
            let entity = this.rightFacesMap[key];
            if (!!entity && !!entity?.rangeShoot(this._pickBox._frustum)) {
                rightSelected.push(key);
            }
        }
        if (rightSelected.length <= 0) return null;
        // 寻找离相机最近的面
        const cameraPosition = this.extraContext.getCurrentViewEditor().camera.position;
        let region = null;
        let boundingWallCurveIndex = null;
        let shortestDistance = Infinity;
        for (let i = 0; i < rightSelected.length; i++) {
            let key = rightSelected[i]
            const distance = this.rightFacesMap[key].getBoundingBox().distanceToPoint(cameraPosition)
            if (distance < shortestDistance) {
                region = this.rightFacesMap[key];
                shortestDistance = distance;
                boundingWallCurveIndex = key;
            }
        }
        this.boundingWallCurveIndex = +boundingWallCurveIndex;
        return region;
    }
}